import React from 'react';
import classNames from 'classnames';
import { SegmentsMenuContent } from './SegmentsMenuContent';
import './NavMenuDesktop.scss';
import { useDelayedOffSwitch } from '../../../../../util/useDelayedOffSwitch';
var SpeechBubbleTip = function SpeechBubbleTip() {
  return /*#__PURE__*/React.createElement("div", {
    className: "speech-bubble-tip"
  });
};
export var NavMenuDesktop = function NavMenuDesktop(_ref) {
  var open = _ref.open,
    segments = _ref.segments;
  var transition = useDelayedOffSwitch(open, 200);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('NavMenuDesktop', {
      open: open,
      transition: transition
    })
  }, /*#__PURE__*/React.createElement(SpeechBubbleTip, null), /*#__PURE__*/React.createElement(SegmentsMenuContent, {
    segments: segments,
    maxColumnLength: 6
  }));
};